import { render, staticRenderFns } from "./BaseNoItemBanner.vue?vue&type=template&id=44f4aa13&scoped=true&"
import script from "./BaseNoItemBanner.vue?vue&type=script&lang=js&"
export * from "./BaseNoItemBanner.vue?vue&type=script&lang=js&"
import style0 from "./BaseNoItemBanner.vue?vue&type=style&index=0&id=44f4aa13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f4aa13",
  null
  
)

export default component.exports